import { featuresData } from '@/mocks/homeData';

export default function SectionFeatures() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            平台优势
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            为什么千万吃瓜群众选择我们
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featuresData.map((feature, index) => (
            <div
              key={feature.id}
              className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70 text-center"
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 mx-auto rounded-full flex items-center justify-center mb-4 ${
                index === 0 ? 'bg-primary-100 text-primary-600' :
                index === 1 ? 'bg-accent-100 text-accent-600' :
                index === 2 ? 'bg-secondary-100 text-secondary-600' :
                'bg-primary-100 text-primary-600'
              }`}>
                <i className={`${feature.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}